import { Component, Prop, Vue } from 'vue-property-decorator'
@Component
export default class extends Vue {
  @Prop({}) private placeholder
  @Prop({}) private isDisabled
  @Prop({}) private search
  @Prop({}) private resetText
  private text = ''
  private resetSearch() {
    this.text = ''
    this.resetText(this.text)
  }
  private funcSearch(text) {
    if (this.text.length > 0) {
      this.search(text)
    }
  }
}
